module.exports = __webpack_public_path__ + "static/media/boltRed.5c1adacd.svg";